export default "__VITE_ASSET__266008b9__"